import router from './router'
import useProfileStore from './store'
import ProfileMessages from './localization'

export default {
  router,
  store: useProfileStore,
  localization: ProfileMessages,
}
